import Crud from '../components/User/Crud'
import Add from '../components/User/Add'
import Edit from '../components/User/Edit'
import View from '../components/User/View'

let routes = {
    path: '/users',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/users',
            name: 'Usuários',
            component: Crud
        },
        {
            path: '/users/add',
            name: 'Novo Usuário',
            component: Add
        },
        {
            path: '/users/edit/:id',
            name: 'Editar Usuário',
            component: Edit
        },
        {
            path: '/users/view/:id',
            name: 'Usuário',
            component: View
        },
    ]
};


export default routes



// WEBPACK FOOTER //
// ./src/router/user.js